import React from "react";
import {
  f7,
  Page,
  Button,
  Swiper,
  SwiperSlide,
  Navbar,
  NavLeft,
  NavTitle,
  NavRight,
  Link,
  Card,
  CardHeader,
  CardContent,
  CardFooter,
  Row,
  Col,
  Tabs,
  Tab,
  Block,
  List,
  ListInput,
  ListItem,
  Icon,
  Popup,
} from "framework7-react";

import {
  PrimaryLogo,
  MerchantSvg,
  FoodSvg,
  BikeSvg,
} from "../components/crumbs";

// Redux
import { compose } from "redux";
import { connect } from "react-redux";
import { withFirebase, withFirestore } from "../HOCs";
import { generateId, handleErrors, toast, isAllowed } from "../utils/_helpers";
// import { functions } from 'firebase';

class OnBoarding extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popupOpened: false,
      popupDataChanged: false,
      recoveryEmail: "",
      recoveryEmailButton: "Send",
      register: {
        fullName: "",
        email: "",
        password: "",
      },
      registerButton: "Sign Up",
      signInButton: "Sign In",
      onboarding: [
        {
          image: <FoodSvg size="90%" />,
          title: "Order a meal",
          body: `Choose from hundreds of food spots around you and get fast delivery. 
          Each order gives you bonus points for your next meal!.
          Not just eating, it’s an experience.`,
        },
        {
          image: <BikeSvg width="100%" />,
          title: "Delivery Agent",
          body: `Get more delivery orders, Organized earnings report, Access to Delivery history, Track all past earnings, and lots more...`,
        },
        {
          image: <MerchantSvg size="90%" />,
          title: "Sell Online",
          body: `Reach wider audience, Organized sales report, Increased orders and sales, Fast and easy pickups of deliveries, and lots more...`,
        },
      ],
    };
  }

  render() {
    return (
      <Page
        name="onboarding"
        className="bg-color-oldlace"
        id="onboarding-page"
        onPageBeforeIn={this.onPageBeforeIn.bind(this)}
      >
        {/* Top Navbar */}
        <Navbar sliding={false}>
          <NavLeft>
            <Link iconF7="bars" panelOpen="left" />
          </NavLeft>
          <NavTitle sliding>
            {" "}
            <PrimaryLogo size="132px" />{" "}
          </NavTitle>
          <NavRight>
            <Link
              className="onboarding-signin-button"
              onClick={() => this.showForm()}
            >
              Sign In
            </Link>
          </NavRight>
        </Navbar>
        {parseInt(window.innerWidth) <= 800 ? (
          <img
            src="static/pattern-portrait.png"
            className="pattern-bg mobile"
          />
        ) : (
          <img
            src="static/pattern-landscape.png"
            className="pattern-bg desktop"
          />
        )}
        <Row>
          <Col width="100" large="10" style={{ height: "0" }}></Col>
          <Col width="100" large="40" id="swiper-side">
            <Swiper
              params={{
                speed: 2000,
                slidesPerView: 1,
                spaceBetween: 16,
                effect: "slide",
                grabCursor: true,
                loop: true,
                autoplay: { delay: 5000 },
              }}
              // pagination
              id="onboarding"
            >
              {this.state.onboarding.map((a, index) => (
                <SwiperSlide key={index} style={{ width: "100%" }}>
                  <div className="paddingWrapper">
                    <h1>{a.title}</h1>
                  </div>

                  <Card
                    className="onboarding-illustration-card"
                    style={{
                      margin: "20px auto",
                      boxShadow: "none",
                    }}
                  >
                    <CardHeader className="no-border no-padding">
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                        }}
                      >
                        {a.image}
                      </div>
                    </CardHeader>
                  </Card>

                  <Block>
                    <Card style={{ margin: "0px auto" }}>
                      <CardContent>
                        <p style={{ textAlign: "left", margin: 0 }}>{a.body}</p>
                      </CardContent>
                      {parseInt(window.innerWidth) < 800 ? (
                        <CardFooter className="onboarding-signin-button">
                          <Button
                            round
                            outline
                            tabLink="#view-map"
                            onClick={() => f7.methods.navMain("map")}
                            transition="f7-circle"
                            style={{ width: "45%" }}
                          >
                            Get Started
                          </Button>
                          <Button
                            round
                            fill
                            transition="f7-circle"
                            style={{ width: "45%" }}
                            onClick={() => this.showForm()}
                          >
                            Sign In
                          </Button>
                        </CardFooter>
                      ) : null}
                    </Card>
                  </Block>
                </SwiperSlide>
              ))}
            </Swiper>
          </Col>
          <Col width="100" large="50" id="form-side">
            <Tabs animated style={{ overflowY: "scroll" }}>
              <Tab id="tab-signin" className="page-content" tabActive>
                <Block>
                  <Card style={{ margin: "3vh auto 0 auto" }}>
                    <CardHeader className="no-border">
                      <h1
                        style={{
                          marginTop: 0,
                          marginBottom: 0,
                          fontSize: "40px",
                        }}
                      >
                        Sign In
                      </h1>
                    </CardHeader>
                    <CardContent>
                      <List noHairlinesMd form id="signin-form">
                        <ListInput
                          label="E-mail"
                          type="email"
                          name="email"
                          placeholder="Please enter e-mail address here"
                          info="Default e-mail validation"
                          required
                          validate
                          clearButton
                        >
                          <Icon f7="envelope" slot="media" />
                        </ListInput>

                        <ListInput
                          label="Password"
                          type="password"
                          name="password"
                          placeholder="Please enter password here"
                          info="Default password validation"
                          required
                          validate
                          clearButton
                        >
                          <Icon f7="lock" slot="media" />
                        </ListInput>
                      </List>
                    </CardContent>
                    <CardFooter>
                      <Button round outline tabLink="#tab-forgot">
                        Forgot Email/Password?
                      </Button>
                      <Button
                        round
                        fill
                        style={{ width: "40%" }}
                        disabled={this.state.signInButton !== "Sign In"}
                        onClick={this.login.bind(this)}
                      >
                        {this.state.signInButton}
                      </Button>
                    </CardFooter>
                  </Card>
                  <Card style={{ margin: "10pt auto" }}>
                    <CardFooter>
                      <small>Don't have an account?</small>
                      <Button
                        round
                        outline
                        tabLink="#tab-register"
                        style={{ width: "40%" }}
                      >
                        Register
                      </Button>
                    </CardFooter>
                  </Card>
                  <Card style={{ margin: "10pt auto" }}>
                    <CardFooter>
                      <small>No Sign In Required</small>
                      <Button
                        round
                        outline
                        tabLink="#view-map"
                        onClick={() => f7.methods.navMain("map")}
                        style={{ width: "40%" }}
                      >
                        Quick Browse
                      </Button>
                    </CardFooter>
                  </Card>
                </Block>
              </Tab>
              <Tab id="tab-register" className="page-content">
                <Block>
                  <Card style={{ margin: "3vh auto 0 auto" }}>
                    <CardHeader className="no-border">
                      <h1
                        style={{
                          marginTop: 0,
                          marginBottom: 0,
                          fontSize: "40px",
                        }}
                      >
                        Register
                      </h1>
                    </CardHeader>
                    <CardContent>
                      <List noHairlinesMd form id="register-form">
                        <ListInput
                          label="Full Name"
                          type="text"
                          name="fullName"
                          placeholder="Please enter your full name here"
                          info="Default validation"
                          required
                          validate
                          clearButton
                        >
                          <Icon f7="person" slot="media" />
                        </ListInput>

                        <ListInput
                          label="Phone Number"
                          type="number"
                          min="0"
                          name="phone"
                          placeholder="Please enter your phone number here"
                          info="Phone number is required for deliveries"
                          required
                          validate
                          clearButton
                        >
                          <Icon f7="phone" slot="media" />
                        </ListInput>

                        <ListInput
                          label="E-mail"
                          type="email"
                          name="email"
                          placeholder="Please enter e-mail address here"
                          info="Default e-mail validation"
                          required
                          validate
                          clearButton
                        >
                          <Icon f7="envelope" slot="media" />
                        </ListInput>

                        <ListInput
                          label="Password"
                          type="password"
                          name="password"
                          placeholder="Please enter password here"
                          info="Default password validation"
                          required
                          clearButton
                        >
                          <Icon f7="lock" slot="media" />
                        </ListInput>

                        <ListItem>
                          <Icon f7="info_circle" slot="media" color="blue" />
                          <Link
                            onClick={() => {
                              this.setState({
                                ...this.state,
                                popupOpened: true,
                                popupDataChanged: true,
                                websitePage: "tos.php#app",
                              });
                            }}
                            slot="title"
                            style={{
                              fontSize: "10px",
                              color: "#e6a859",
                              fontWeight: "bold",
                            }}
                          >
                            By Signing Up you agree to Easychaw Terms Of Service
                          </Link>
                        </ListItem>
                      </List>
                    </CardContent>
                    <CardFooter>
                      <Button
                        round
                        fill
                        style={{ width: "100%" }}
                        disabled={this.state.registerButton !== "Sign Up"}
                        onClick={this.register.bind(this)}
                      >
                        {this.state.registerButton}
                      </Button>
                    </CardFooter>
                  </Card>
                  <Card style={{ margin: "10pt auto" }}>
                    <CardFooter>
                      <small>Have an account?</small>
                      <Button
                        round
                        outline
                        tabLink="#tab-signin"
                        style={{ width: "50%" }}
                      >
                        Sign In
                      </Button>
                    </CardFooter>
                  </Card>
                  <Card style={{ margin: "10pt auto" }}>
                    <CardFooter>
                      <small>No Sign In Required</small>
                      <Button
                        round
                        outline
                        tabLink="#view-map"
                        onClick={() => f7.methods.navMain("map")}
                        style={{ width: "50%" }}
                      >
                        Quick Browse
                      </Button>
                    </CardFooter>
                  </Card>
                </Block>
              </Tab>
              <Tab id="tab-forgot" className="page-content">
                <Block>
                  <Card style={{ margin: "3vh auto 0 auto" }}>
                    <CardHeader className="no-border">
                      <h1
                        style={{
                          marginTop: 0,
                          marginBottom: 0,
                          fontSize: "40px",
                        }}
                      >
                        Recover Account
                      </h1>
                    </CardHeader>
                    <CardContent>
                      <List noHairlinesMd form id="forgot-form">
                        <ListInput
                          label="E-mail"
                          type="email"
                          placeholder="Please enter e-mail address here"
                          info="Default e-mail validation"
                          required
                          validate
                          value={this.state.recoveryEmail}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              recoveryEmail: e.target.value,
                            })
                          }
                          clearButton
                        >
                          <Icon f7="envelope" slot="media" />
                        </ListInput>
                      </List>
                    </CardContent>
                    <CardFooter>
                      <Button
                        round
                        fill
                        style={{ width: "100%" }}
                        disabled={this.state.recoveryEmailButton !== "Send"}
                        onClick={this.recoverPassword.bind(this)}
                      >
                        {this.state.recoveryEmailButton}
                      </Button>
                    </CardFooter>
                  </Card>
                  <Card style={{ margin: "10pt auto" }}>
                    <CardFooter>
                      <small>Have an account?</small>
                      <Button
                        round
                        outline
                        tabLink="#tab-signin"
                        style={{ width: "50%" }}
                      >
                        Sign In
                      </Button>
                    </CardFooter>
                  </Card>
                  <Card style={{ margin: "10pt auto" }}>
                    <CardFooter>
                      <small>No Sign In Required </small>
                      <Button
                        round
                        outline
                        tabLink="#view-map"
                        onClick={() => f7.methods.navMain("map")}
                        style={{ width: "40%" }}
                      >
                        Quick Browse
                      </Button>
                    </CardFooter>
                  </Card>
                </Block>
              </Tab>
            </Tabs>
          </Col>
        </Row>

        {/* Popup for website links */}
        <Popup
          swipeToClose="to-bottom"
          className="website-popup"
          opened={this.state.popupOpened}
          onPopupClosed={() =>
            this.setState({
              ...this.state,
              popupOpened: false,
              popupDataChanged: false,
              websitePage: "",
            })
          }
        >
          <Page>
            <Navbar>
              <NavRight>
                <Link popupClose>Close</Link>
              </NavRight>
              <NavTitle sliding>Website</NavTitle>
            </Navbar>
            {/* Page content */}
            {this.state.popupOpened ? (
              <iframe
                src={`https://www.easychaw.com/${this.state.websitePage}`}
                style={{
                  height: "100%",
                  width: "100%",
                  border: "none",
                  position: "relative",
                  zIndex: "1",
                }}
              ></iframe>
            ) : null}

            {/* Background */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                padding: 0,
                width: "100%",
                margin: 0,
                height: "100%",
                backgroundColor: "#fed448",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                zIndex: 0,
              }}
            >
              <PrimaryLogo size="132px" />
              <h6
                className="glow"
                style={{
                  animationIterationCount: "infinite",
                  color: "rgba(22,22,22,0.52)",
                }}
              >
                Loading page
              </h6>
            </div>
          </Page>
        </Popup>
      </Page>
    );
  }

  //events
  //Page before in
  onPageBeforeIn() {
    // check if url has merchant name
    let searchMerchant = window.location.search.split("=");
    if (searchMerchant.length > 1) this.$f7.methods.navMain("map");
  }

  // Login
  login() {
    this.setState({ ...this.state, signInButton: "Signing In..." });
    const self = this;

    const { email, password } = self.$f7.form.convertToData("#signin-form");
    this.props.firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(({ user }) => {
        this.setState({ ...this.state, signInButton: "Sign In" });
        this.props.firestore
          .collection("users")
          .doc(user.uid)
          .get()
          .then((profile) => {
            if (profile.data()?.accountStatus === "Suspended") {
              self.$f7.dialog.alert(
                "Your account has been suspended. Contact admin via support@easychaw.com",
              );
              return this.props.firebase.auth().signOut();
            }
            self.$f7.tab.show("#view-map");
            self.$f7.methods.navMain("map");
          });
      })
      .catch(({ code, message }) => {
        switch (code) {
          case "auth/user-not-found":
            toast(this.$f7.toast, {
              text: message,
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
            break;
          case "auth/invalid-email":
            toast(this.$f7.toast, {
              text: "Invalid Email/Password",
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });

            break;
          case "auth/wrong-password":
            toast(this.$f7.toast, {
              text: "Invalid Email/Password",
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });

            break;
          default:
            toast(this.$f7.toast, {
              text: "Something went wrong",
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
        }
        this.setState({ ...this.state, signInButton: "Sign In" });
      });
  }

  // Register
  register() {
    this.setState({ ...this.state, registerButton: "Signing Up..." });
    const self = this;
    const { fullName, phone, email, password } =
      self.$f7.form.convertToData("#register-form");
    // Validate fullname
    if (fullName.trim() === "") {
      toast(this.$f7.toast, {
        text: "Please fill out the fullname field",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });

      return this.setState({ ...this.state, registerButton: "Sign Up" });
    }

    if (phone.trim() === "") {
      toast(this.$f7.toast, {
        text: "Please fill out the phone number field",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });

      return this.setState({ ...this.state, registerButton: "Sign Up" });
    }

    if (phone.trim().length !== 11) {
      toast(this.$f7.toast, {
        text: "Please provide a valid phone number",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });

      return this.setState({ ...this.state, registerButton: "Sign Up" });
    }

    isAllowed(
      {
        token: "",
        uid: "",
        details: { collection: "users", property: "phoneNumber", value: phone },
      },
      (error, success) => {
        if (error) {
          this.setState({
            ...this.state,
            registerButton: "Sign Up",
          });
          return toast(this.$f7.toast, {
            text: error,
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
        }
        this.props.firebase
          .auth()
          .createUserWithEmailAndPassword(email, password)
          .then(({ user }) => {
            const walletId = generateId(7);

            this.props.firestore
              .collection("users")
              .doc(user.uid)
              .set({
                email,
                fullName,
                phoneNumber: phone,
                role: "Basic",
                accountStatus: "Approved",
                lastUpdated: Date.now(),
                walletId,
              })
              .then((doc) => {
                this.setState({
                  ...this.state,
                  registerButton: "Sign Up",
                  register: {
                    ...this.state.register,
                    fullName: "",
                    email: "",
                    password: "",
                  },
                });

                f7.methods.navMain("map");
              })
              .catch((error) => {
                this.setState({
                  ...this.state,
                  registerButton: "Sign Up",
                });
                return toast(this.$f7.toast, {
                  text: handleErrors(error),
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
              });

            //sign user out and switch to sign in tab
            // this.props.firebase
            //   .auth()
            //   .signOut()
            //   .then(() => {
            //     let text = 'Account created successfully, please sign in.';
            //     toast(this.$f7.toast, {
            //       text,
            //       position: 'bottom',
            //       horizontalPosition: 'center',
            //       closeButton: true,
            //       cssClass: 'custom-toast',
            //       closeTimeout: 4000,
            //     });
            //     self.$f7.tab.show('#tab-signin');
            //   })
            //   .catch((error) => {
            //     return toast(this.$f7.toast, {
            //       text: handleErrors(error),
            //       position: 'bottom',
            //       horizontalPosition: 'center',
            //       closeButton: true,
            //       cssClass: 'custom-toast',
            //       closeTimeout: 4000,
            //     });
            //   });
          })
          .catch(({ code, message }) => {
            switch (code) {
              case "auth/email-already-in-use":
                toast(this.$f7.toast, {
                  text: message,
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });

                break;
              case "auth/invalid-email":
                toast(this.$f7.toast, {
                  text: "Invalid Email Address",
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });

                break;
              case "auth/weak-password":
                toast(this.$f7.toast, {
                  text: message,
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });

                break;
              default:
                toast(this.$f7.toast, {
                  text: "Something went wrong",
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
            }

            this.setState({
              ...this.state,
              registerButton: "Sign Up",
            });
          });
      },
    );
  }

  // Forgot Password
  recoverPassword() {
    this.setState({ ...this.state, recoveryEmailButton: "Sending..." });
    const self = this;
    const { recoveryEmail } = this.state;
    this.props.firebase
      .auth()
      .sendPasswordResetEmail(recoveryEmail)
      .then(() => {
        // Successfull
        toast(this.$f7.toast, {
          text: "A Password reset email has been sent to " + recoveryEmail,
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });

        this.setState({
          ...this.state,
          recoveryEmail: "",
          recoveryEmailButton: "Send",
        });
      })
      .catch(({ code, message }) => {
        // Unsucessful
        switch (code) {
          case "auth/user-not-found":
            toast(this.$f7.toast, {
              text: message,
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });

            return this.setState({
              ...this.state,
              recoveryEmail: "",
              recoveryEmailButton: "Send",
            });

          case "auth/invalid-email":
            toast(this.$f7.toast, {
              text: "Invalid Email Address",
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });

            return this.setState({
              ...this.state,
              recoveryEmail: "",
              recoveryEmailButton: "Send",
            });
          default:
            toast(this.$f7.toast, {
              text: "Something went wrong",
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });

            return this.setState({
              ...this.state,
              recoveryEmail: "",
              recoveryEmailButton: "Send",
            });
        }
      });
  }

  showForm() {
    const self = this;
    self.$f7.$("#swiper-side").css({ display: "none" });
    self.$f7.$("#form-side").css({ display: "block" });
  }
}

const mapStateToProps = ({ firebase: { auth, profile } }) => ({
  auth,
  profile,
});

const enhance = compose(withFirebase, withFirestore, connect(mapStateToProps));

export default enhance(OnBoarding);
